import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Coming soon...
      </header>
    </div>
  );
}

export default App;
